import { CRRender } from '@/components/crRender'
import CRRequestFlow from './components'
import {  FLOW_STEPS } from '@/data/status'
import { formatDate } from '@/utils/dateUtils'
import { translate } from '@/utils/langUtils'
import { Icon } from '@iconify/react/dist/iconify.js'

const RequestInfo = ({ requestDetails, PrevRef }: { requestDetails: any, PrevRef: any }) => {
    return (
        <>

            <div className="row">
                <div className=" col-8">
                    <h2 className="rd-request-number">
                        {translate("Request Number")}: {requestDetails?.id}
                    </h2>
                    <p className="rd-request-date">
                        {formatDate(requestDetails?.orderDate)}
                    </p>
                </div>
                <div className="col-4 text-center" onClick={() => PrevRef?.current?.click()}>
                    <div className="rd-prev-date">
                        {translate("prev-offer")}
                    </div>
                </div>
            </div>

            <div className="rd-stepper-card">
                <CRRequestFlow steps={FLOW_STEPS} currentStep={requestDetails?.orderStatusId} />
            </div>

            <div className="rd-info-bar">
                <div className="rd-info-item">
                    <span className="rd-info-label">{translate("Request Status")}</span>
                    <span className={`rd-status-badge status-${requestDetails?.orderStatusId}`}>
                        {translate(requestDetails?.orderStatusName)?.toUpperCase()}
                    </span>
                </div>

                <CRRender isRender={!!requestDetails?.categoryName}>
                    <div className="rd-info-item">
                        <Icon icon="nrk:category-active" className="rd-info-icon" />
                        <span>{requestDetails?.categoryName}</span>
                    </div>
                </CRRender>

                <CRRender isRender={!!requestDetails?.subCategoryName}>
                    <div className="rd-info-item">
                        <Icon icon="fa-solid:pump-medical" className="rd-info-icon" />
                        <span>{requestDetails?.subCategoryName}</span>
                    </div>
                </CRRender>

                <div className="rd-info-item">
                    <Icon icon="solar:calendar-date-bold" className="rd-info-icon" />
                    <span>{translate("Request date")}</span>
                    <span className="rd-info-date">
                        {formatDate(requestDetails?.orderDate)}
                    </span>
                </div>
            </div>
            <div className="rd-tabs">
                <div className="rd-tab active">{translate("Available Hospital")}</div>
            </div>

        </>
    )
}

export default RequestInfo